import { UUID } from '@macs-frontend/core/utils/uuid';

export enum Genders {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}

export enum AgeRanges {
  age_12_14 = '12-14',
  age_15_24 = '15-24',
  age_25_34 = '25-34',
  age_35_44 = '35-44',
  age_45_54 = '45-54',
  age_55_64 = '55-64',
  age_65_more = '> 65',
  age_65_plus = '65+',
}

export type Ages =
  | AgeRanges.age_12_14
  | AgeRanges.age_15_24
  | AgeRanges.age_25_34
  | AgeRanges.age_35_44
  | AgeRanges.age_45_54
  | AgeRanges.age_55_64
  | AgeRanges.age_65_more
  | AgeRanges.age_65_plus;

export interface Age {
  age: Ages;
  selected: boolean;
}

export interface FilterGender {
  gender: Genders;
  selected: boolean;
}

export interface BaseTargetGroupFilter {
  uuid: UUID;
  name: string;
}

export interface TargetGroupFilter extends BaseTargetGroupFilter {
  ages: Age[];
  genders: FilterGender[];
}
